import router from './router/index'
// import { Message } from 'element-ui'
import axios from 'axios'
import Qs from 'qs'
const _import = require('./router/_import_' + process.env.NODE_ENV) //获取组件的方法
import Layout from '@/components/public/layout' //Layout 是架构组件，不在后台返回，在文件里单独引入


var getRouter //用来获取后台拿到的路由

// 假装fakeRouter是通过后台接口请求回来的数据


// [
//   {
//     "path": "/",
//     "name": "login",
//     "component": "public/login",
//     "meta":{"title":"艾媒数聚后台管理系统"},
//     "hidden": "true"
//   },
//   {
//     "path": "/sys/tree",
//     "component": "Layout",
//     "redirect": "/sys/tree/catchManager",
//     "name": "树的管理",
//     "children": [
//       { "path": "catchManager", "component": "tree/catchManager", "name": "抓取管理","meta":{"title":"艾媒数聚后台管理系统"} },     

//     ]
//   },
// ]

let fakeRouter = {
  "router": [
    //     {"menu_id":1,"level":1,
    //     "component":"Layout",
    //     "name":"树的管理",
    //     "path":"/sys/tree",
    //     "children":[
    //       {"component":"tree/catchManager","name":"抓取管理","path":"catchManager","meta":"{\"title\":\"艾媒数聚后台管理系统\"}"}
    //     ],
    //     "redirect":"/sys/tree/catchManager",
    //     "p_id":0
    //   },
    //     {"menu_id":2,"level":1,
    //     "component":"Layout",
    //     "name":"数据审核",
    //     "path":"/sys/datareview",
    //     "children":[
    //       {"component":"datareview/sendreview","name":"送审列表","path":"sendreview","meta":"{\"title\":\"艾媒数聚后台管理系统\"}"}
    //     ],
    //     "redirect":"/sys/datareview/sendreview",
    //     "p_id":0}
    {
      "menu_id": 1,
      "level": 1,
      "component": "Layout",
      "name": "树的管理",
      "path": "/sys/tree",
      "children": [{
          "menu_id": 7,
          "component": "tree/catchManager",
          "name": "抓取管理",
          "path": "catchManager",
          "meta": "{\"title\":\"艾媒数聚后台管理系统\"}"
        },
        {
          "menu_id": 8,
          "component": "tree/sourceTreeManager",
          "name": "源树管理",
          "path": "sourceTreeManager",
          "meta": "{\"title\":\"艾媒数聚后台管理系统\"}"
        },
        {
          "menu_id": 9,
          "component": "tree/moveTreeManager",
          "name": "移花接木",
          "path": "moveTreeManager",
          "meta": "{\"title\":\"艾媒数聚后台管理系统\"}"
        },
      ]
    }
  ]

}
router.beforeEach((to, from, next) => {
  if (!getRouter) { //不加这个判断，路由会陷入死循环
    if (!getObjArr('router')) {
      // console.log('获取路由')
      axios.post('/sysback/getMenuTreeByUserRole', Qs.stringify({})).then(res => {
        if (res.data.code == '-12') {
          //尚未登陆，跳到统一后台登录页
          window.location.href = 'https://imadmin.iimedia.com.cn/iimediaAdmin/#/'
        } else {
          getRouter = res.data.data
          saveObjArr('router', getRouter) //存储路由到localStorage
          routerGo(to, next) //执行路由跳转方法
        }

      })
    } else { //从localStorage拿到了路由
      getRouter = getObjArr('router') //拿到路由
      // console.log(getRouter)
      routerGo(to, next)
    }
  } else {
    next()
  }

})


function routerGo(to, next) {
  getRouter = filterAsyncRouter(getRouter) //过滤路由
  router.addRoutes(getRouter) //动态添加路由
  global.antRouter = getRouter //将路由数据传递给全局变量，做侧边栏菜单渲染工作
  next({
    ...to,
    replace: true
  })
}

function saveObjArr(name, data) { //localStorage 存储数组对象的方法
  localStorage.setItem(name, JSON.stringify(data))
}

function getObjArr(name) { //localStorage 获取数组对象的方法
  return JSON.parse(window.localStorage.getItem(name));

}

function filterAsyncRouter(asyncRouterMap) { //遍历后台传来的路由字符串，转换为组件对象
  const accessedRouters = asyncRouterMap.filter(route => {
    if (route.component) {
      if (route.component === 'Layout') { //Layout组件特殊处理
        route.component = Layout
      } else {
        route.component = _import(route.component)
      }
    }
    if (route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children)
    }
    return true
  })

  return accessedRouters
}



// WEBPACK FOOTER //
// ./src/promission.js